import { render, staticRenderFns } from "./Simulator.vue?vue&type=template&id=2c2ecbdf&scoped=true"
import script from "./Simulator.vue?vue&type=script&lang=js"
export * from "./Simulator.vue?vue&type=script&lang=js"
import style0 from "./Simulator.vue?vue&type=style&index=0&id=2c2ecbdf&prod&scoped=true&lang=css"
import style1 from "./Simulator.vue?vue&type=style&index=1&id=2c2ecbdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2ecbdf",
  null
  
)

export default component.exports